import * as React from 'react';
import styled from 'styled-components';
import { Colors } from '@prezi/dragon';
import { CloseIcon } from '../Icons';

type ButtonProps = {
    onClose: () => void;
    color?: string;
    isOutside?: boolean;
};

const CloseButtonWrapper = styled.button<{ isOutside: boolean }>`
    position: absolute;
    cursor: pointer;
    z-index: 2;
    width: 32px;
    height: 32px;
    border-radius: 50%;
    background-color: rgba(255, 255, 255, 0);
    transition: background-color 0.2s;
    border: none;
    padding: 0;
    display: flex;

    &:hover {
        background-color: ${Colors.neutral200};
    }
    ${p =>
        p.isOutside
            ? `
        right: -32px;
        top: -12px;
    `
            : `
        right: 16px;
        top: 12px;
    `}
`;

const CloseButton = ({ onClose, color, isOutside = false }: ButtonProps) => (
    <CloseButtonWrapper
        onClick={() => onClose()}
        onKeyPress={event => event.key === 'Enter' && onClose()}
        isOutside={isOutside}
        data-lookup="close-modal-button"
    >
        <CloseIcon width={32} height={32} fill={color} />
    </CloseButtonWrapper>
);

export default CloseButton;
